import React from 'react';
import { IconProps } from '../types/types';

const GALBSC: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" role="img" {...props}><g clipPath="url(#a)"><path d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z" fill="#000"/><path stroke="#fff" strokeLinecap="round" d="M6 9.293 9.293 6M11 14.293 14.293 11M6 14.293 14.293 6"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h19.951v20H0z"/></clipPath></defs></svg>
);

export default GALBSC;
